import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { VolunteerService } from "../../services/volunteer.service";
import { VolunteerRegistration } from "../../models/volunteer.model";
import { LocalstorageService } from "../../services/localstorage.service";
import * as moment from "moment";
import { ToastrWrapperService } from "../../services/toastr-wrapper.service";
import { LastQuestionAnswer } from "../../models/volunteer-last-question-answer.model";

@Component({
  selector: "app-volunteer-dialog",
  templateUrl: "./volunteer-dialog.component.html",
})
export class VolunteerDialogComponent implements OnInit {
  isSubmitting: boolean;
  volunteerRegistration: VolunteerRegistration;
  isShow: boolean = true;
  activityId: number;
  activityQuestionId: number;

  constructor(
    public volunteerService: VolunteerService,
    public dialogRef: MatDialogRef<VolunteerDialogComponent>,
    public router: Router,
    private localstorageService: LocalstorageService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toasterWrapper: ToastrWrapperService
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
    let questionIds = this.data.actQuestions.map(item => item.volunteerActivityQuestionId).toString();

    this.volunteerService.getLastVolunteerQuestionAnswer(this.data.corpId, questionIds).subscribe(
      answers => {
        this.data.actQuestions = this.data.actQuestions.map(q => ({
          ...answers.find((a) => (q.volunteerActivityQuestionId === a.volunteerActivityQuestionId)),
          ...q
        }))
      });

    this.isShow = this.data.isShow;
  }

  onClick(activityId, questionId) {
    this.activityId = activityId;
    this.activityQuestionId = questionId;
  }

  btnIsDisabled() {
    var unAnsweredMandatoryQuestions = false;
    this.data.actQuestions.forEach(q => {
      if (q.volunteerActivityQuestionRequired && !q.activityQuestionAnswer) {
        unAnsweredMandatoryQuestions = true;
      }
    });


    if (this.data.tmPhone.length < 10)
      return true;
    else if (unAnsweredMandatoryQuestions)
      return true;
    else
      return false;

  }

  success(actDateIds, remRegIds, remDateIds, actDatesOnly, remDatesOnly, actDates) {
    this.isSubmitting = true;
    let authDetails = this.localstorageService.getAuth();
    let allRequiredQuestionsAnswered: Boolean = true;
    let missingQuestionAnswers: string = "";

    console.log('actDates: ', actDates);

    var registrationModels = [];
    var registrationModel = {};

    for (var i = 0; i <= actDateIds.length - 1; i++) {
      var actDatesString = actDates[i].split("|");
      var activityId = actDatesString[0];

      let questionAnswer = this.data.actQuestions.filter(f => f.volunteerActivityId == activityId)[0].activityQuestionAnswer;

      let answer = questionAnswer ? "true" : "false";
      let questionId = this.data.actQuestions.filter(f => f.volunteerActivityId == activityId)[0].volunteerActivityQuestionId;
      if (questionId == null) {
        questionId = 0;
      }

      let isRequired = this.data.actQuestions.filter(f => f.volunteerActivityId == activityId)[0].volunteerActivityQuestionRequired;
      let questionText = this.data.actQuestions.filter(f => f.volunteerActivityId == activityId)[0].volunteerActivityQuestionText;

      if (isRequired && answer == "false") {
        allRequiredQuestionsAnswered = false;
        missingQuestionAnswers = missingQuestionAnswers + questionText + "\n";
      }
  
      console.log(actDatesOnly[i]);
      registrationModel = {
        volunteerCorpId: authDetails.employeeInfo.corpId,
        volunteerPhoneNumber: this.data.tmPhone,
        volunteerNote: '',
        criticalNote: false,
        volActivityShiftId: this.data.modifiedActivityDates.find(
          (m) => m.volunteerActivityDateId == actDateIds[i]
        ).volActivityShiftID,
        volunteerActivityDateId: actDateIds[i],
        activityDate: moment(actDatesOnly[i]).format('YYYY-MM-DD'),
        enteredBy: authDetails.employeeInfo.corpId,
        activeFlag: true,
        activityQuestionAnswer: answer,
        activityQuestionId: questionId
      };

      registrationModels.push(registrationModel);
    }

    for (var i = 0; i <= remRegIds.length - 1; i++)
    {
      registrationModel = {
        volunteerCorpId: authDetails.employeeInfo.corpId,
        volunteerPhoneNumber: this.data.tmPhone,
        volunteerNote: '',
        criticalNote: false,
        volActivityShiftId: this.data.modifiedActivityDates.find(
          (m) => m.volunteerActivityDateId == remDateIds[i]
        ).volActivityShiftID,
        volunteerActivityDateId: remDateIds[i],
        activityDate: moment(remDatesOnly[i]).format('YYYY-MM-DD'),
        enteredBy: authDetails.employeeInfo.corpId,
        activeFlag: false,
        activityQuestionAnswer: "false",
        activityQuestionId: 0
      };

      registrationModels.push(registrationModel);
    }

    if (allRequiredQuestionsAnswered) {
      console.log('saving', registrationModels)
      this.volunteerService
        .saveVolunteerRegistration(registrationModels)
        .subscribe(
          (responseData) => {
            //success
            console.log(responseData);
            this.isSubmitting = false;
            this.toasterWrapper.showSuccess("Thank you for volunteering!");
            this.router.navigate(["/volunteer"]);
          },
          (error) => {
            console.error(error);
            this.toasterWrapper.showError(JSON.stringify(error.error));
            this.isSubmitting = false;
          }
        );

      this.dialogRef.close();
    }
    //else {
    //  alert("The following questions are required: \n" + missingQuestionAnswers);
    //}
    
  }
}
